export default "__VITE_ASSET__Dc1bWk0L__"